var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }, [_c("w-spacer")], 1),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("settings")))]),
                      _c(
                        "w-card-content",
                        [
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-input", {
                                    attrs: {
                                      fancy: "",
                                      label: _vm.$ct("unit-field-name"),
                                    },
                                    model: {
                                      value: _vm.generalConfig.UnitFieldName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.generalConfig,
                                          "UnitFieldName",
                                          $$v
                                        )
                                      },
                                      expression: "generalConfig.UnitFieldName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-card-actions",
                        [
                          _c("w-spacer"),
                          _c(
                            "w-button",
                            {
                              staticClass: "confirm",
                              attrs: { icon: "save" },
                              on: {
                                click: function ($event) {
                                  return _vm.saveGeneralConfig()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$ct("common.save")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("units")))]),
                      _c(
                        "w-list",
                        [
                          _vm._l(_vm.units, function (unit, i) {
                            return _c(
                              "w-list-item",
                              { key: i },
                              [
                                _c("w-list-item-text", [
                                  _vm._v(
                                    _vm._s(
                                      unit.Name.getTranslation(_vm.selectedLang)
                                    )
                                  ),
                                ]),
                                _c(
                                  "w-list-item-action",
                                  [
                                    _c(
                                      "w-button",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: _vm.$ct("edit-unit"),
                                            expression: "$ct('edit-unit')",
                                          },
                                        ],
                                        on: {
                                          click: function ($event) {
                                            return _vm.editUnit(unit)
                                          },
                                        },
                                      },
                                      [_c("w-fa", { attrs: { icon: "pen" } })],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "w-list-item-action",
                                  [
                                    _c(
                                      "w-button",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: _vm.$ct("delete-unit"),
                                            expression: "$ct('delete-unit')",
                                          },
                                        ],
                                        staticClass: "danger",
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteUnit(unit)
                                          },
                                        },
                                      },
                                      [
                                        _c("w-fa", {
                                          attrs: { icon: "trash" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                          _c(
                            "w-list-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.addUnit()
                                },
                              },
                            },
                            [
                              _c("w-list-item-text", [
                                _c(
                                  "div",
                                  [
                                    _c("w-fa", { attrs: { icon: "plus" } }),
                                    _vm._v(
                                      " " + _vm._s(_vm.$ct("add-unit")) + " "
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditUnit != null } },
        [
          _vm.toEditUnit
            ? _c(
                "w-card",
                { attrs: { "max-width": "500" } },
                [
                  _c("w-card-title", [_vm._v(_vm._s(_vm.editTitle))]),
                  _c(
                    "w-scroll-view",
                    { attrs: { tag: "w-card-content" } },
                    _vm._l(_vm.langs, function (lang) {
                      return _c(
                        "w-row",
                        { key: lang },
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-input", {
                                attrs: { label: lang, fancy: "" },
                                model: {
                                  value: _vm.toEditUnit.Name.Translations[lang],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.toEditUnit.Name.Translations,
                                      lang,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "toEditUnit.Name.Translations[lang]",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _c(
                    "w-card-actions",
                    [
                      _c(
                        "w-button",
                        {
                          staticClass: "danger",
                          on: {
                            click: function ($event) {
                              return _vm.cancelEdit()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
                      ),
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.save()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$ct("common.save")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }